export const Footer = () => {
  return (
    <footer className="py-12 border-t border-neutral-200" data-testid="footer">
      <div className="mx-auto max-w-md px-6 text-center md:max-w-4xl md:px-12 lg:max-w-6xl">
        
        {/* Logo */}
        <div className="flex justify-center mb-4">
          <img
            src="/images/sai-logo.jpg"
            alt="Sense Your Soul Logo"
            className="h-16 w-16 rounded-full object-cover shadow-md ring-2 ring-gold/30"
            loading="lazy"
          />
        </div>

        {/* Brand */}
        <p className="font-serif text-lg text-taupe" data-testid="footer-brand">
          Sense Your Soul
        </p>

        {/* Tagline */}
        <p className="mt-2 text-sm text-taupeLight">
          ดูดวงกับทราย
        </p>

        {/* Keywords */}
        <p className="mt-4 text-xs text-taupeLight" data-testid="footer-keywords">
          ดูดวงความรัก • ไพ่ทาโรต์ออนไลน์ • ดูดวงทางไลน์ • หมอดูความรักแม่น
        </p>

        {/* Social Icons */}
        <div className="mt-6 flex justify-center gap-6">

          {/* Facebook */}
          <a
            href="https://www.facebook.com/profile.php?id=100092714615028"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="transition-transform hover:scale-110"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#1877F2"
              className="h-7 w-7"
            >
              <path d="M22 12.07C22 6.48 17.52 2 11.93 2S2 6.48 2 12.07C2 17.08 5.66 21.21 10.44 22v-7.03H7.9v-2.9h2.54V9.41c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.23.19 2.23.19v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.77l-.44 2.9h-2.33V22C18.34 21.21 22 17.08 22 12.07z" />
            </svg>
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/sense.yoursoul"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="transition-transform hover:scale-110"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="url(#instagramGradient)"
              className="h-7 w-7"
            >
              <defs>
                <linearGradient id="instagramGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#f58529" />
                  <stop offset="30%" stopColor="#dd2a7b" />
                  <stop offset="60%" stopColor="#8134af" />
                  <stop offset="100%" stopColor="#515bd4" />
                </linearGradient>
              </defs>
              <path d="M7.75 2h8.5A5.75 5.75 0 0122 7.75v8.5A5.75 5.75 0 0116.25 22h-8.5A5.75 5.75 0 012 16.25v-8.5A5.75 5.75 0 017.75 2zm4.25 4.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm0 9a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm4.75-9.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z" />
            </svg>
          </a>

        </div>

        {/* Copyright */}
        <p className="mt-8 text-xs text-taupeLight">
          © {new Date().getFullYear()} Sense Your Soul
        </p>

      </div>
    </footer>
  );
};